import script from "./RtbFormHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./RtbFormHeader.vue?vue&type=script&setup=true&lang=js"

import "./RtbFormHeader.vue?vue&type=style&index=0&id=8dd3b7ee&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dd3b7ee"]])

export default __exports__